import React, { createContext, useContext } from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import th from './locales/th.json';

i18n
    .use(LanguageDetector)  // ใช้ LanguageDetector
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            th: { translation: th }
        },
        fallbackLng: 'th',  // ภาษาเริ่มต้นเมื่อไม่พบภาษา
        lng: localStorage.getItem('language') || 'th',  // โหลดภาษาจาก localStorage (ถ้ามี)
        interpolation: {
            escapeValue: false
        },
        detection: {
            order: ['localStorage', 'navigator'],  // ค้นหาภาษาใน localStorage ก่อน
            caches: ['localStorage'],  // ใช้ localStorage ในการเก็บภาษา
        }
    });


export const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
    const t = i18n.t;

    return (
        <I18nContext.Provider value={{ t, i18n }}>
            {children}
        </I18nContext.Provider>
    );
};

export const useI18n = () => {
    const { t } = useContext(I18nContext);
    return t;
};

export default i18n;
